import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import T from '../../app/Locale';
import Modal from '../../app2/Components/ComponentModal';
import Button from '../../app2/Components/ComponentButton';
const ModalConfirm = ({ text, path, closeModal }) => {
    const [isLoading, setIsLoading] = useState(false);
    const onClick = () => {
        setIsLoading(true);
        window.location.href = path;
    };
    return (_jsxs(Modal, Object.assign({ closeModal: closeModal }, { children: [_jsx("h2", { children: T.translate('documents.confirm.title') }), _jsx("p", { dangerouslySetInnerHTML: { __html: text } }), _jsx("br", {}), _jsx("br", {}), _jsx(Button, { id: 'document-action-validate-confirm', title: T.translate('documents.confirm.proceed'), onClick: onClick, isLoading: isLoading }), _jsx(Button, { title: T.translate('documents.confirm.cancel'), onClick: closeModal, classes: 'button transparent' })] })));
};
ModalConfirm.propTypes = {
    text: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    closeModal: PropTypes.func.isRequired
};
export default ModalConfirm;
